<template>
<form action="eqtlGenes" method="get" class="form-inline">
    <fieldset>
        <span>Gene Symbol : </span>
        <div id="search_input" style="display:inline-flex">
            <input name="gene_symbol" type="text" class="form-control mr-sm-2" list="gene_symbol_list2" placeholder="Type here.." v-model="search" v-on:input="getSearchData" autocomplete="off">
            <datalist id="gene_symbol_list2">
                <!-- <option v-for="(result, key) in results" :key="key" :value="result.gene_symbol"></option> -->
                <!-- <option v-for="(result, key) in results" :value="result.gene_symbol"></option> -->
                <option v-for="(result, key) in results" :value="result"></option>
            </datalist>
            <span class="input-group-btn">
                <button type="submit" class="btn btn-primary" :disabled="!isInputExist">Search</button>
            </span>
        </div>
        <div v-if="showHelpMessage" class="search_input_help">
            <small class="text-muted">
                No such Gene Symbol. Input correctly.
            </small>
        </div>
        <div v-if="showInputMessage != ''" class="search_input_help">
            <small class="text-muted">
                {{ this.showInputMessage }}
            </small>
        </div>
    </fieldset>
    <!-- token -->
    <!-- <input type="hidden" name="_token" :value="csrf"> -->
</form>
</template>

<script>
export default {
    data() {
        return {
            // csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            search: '',
            searchBefore: '',
            numOfResults: 0,
            results: [],
            datalistStatus: 'undef',
            showInputMessage: ''
        }
    },
    methods: {
        getSearchData() {
            const HITS_MAX = 300;
            this.showInputMessage = '';
            // 2文字以上の場合、検索判定処理に入る
            if (this.search.length >=2) {
                // 先頭2文字または末尾3文字の変更があった場合、リストを取得させるため、undefにする。
                if ((this.searchBefore.slice(0,2) !== this.search.slice(0,2)) || (this.searchBefore.slice(-3) !== this.search.slice(-3) )) {
                    this.datalistStatus = 'undef'
                    this.results = [];
                }
                const postCountSearchHits = async () => {
                    await axios.post('genes/countSearchHits', {
                        search: this.search
                    }).then(response => {
                        this.numOfResults = response.data;
                        //HITS_MAX 以下の値であれば、前方一致検索の値を取得する。そうでなければ文字の入力を促す。
                        if ((0 < this.numOfResults) && (this.numOfResults < HITS_MAX)){
                            this.searchBefore = this.search;
                            if (this.datalistStatus !== 'def_partial') {
                                this.results = [];
                                axios.post('genes/searchPartial', {
                                    search: this.search
                                }).then(response2 => {
                                    this.results = response2.data;
                                    if (this.results.length > 0) {
                                        this.datalistStatus = 'def_partial';
                                    }
                                }).catch(function (error) {
                                    // console.log(error);
                                    throw error;
                                });
                            }
                        } else if (this.numOfResults >= HITS_MAX) {
                            this.results = [];
                            // 入力をうながずメッセージを表示する。
                            this.showInputMessage = 'Too many hits. Please refine your search term.';
                        } else if (this.numOfResults === 0) {
                            this.datalistStatus = 'undef';
                            this.results = [];
                            this.showInputMessage = 'No hit found.'
                        }
                    });
                }
                postCountSearchHits();
            }
            // 前方一致で取得できない場合（件数が多すぎてリストを取得しない）、完全一致出の検索を試みる
            if ((this.search.length >=2) && (this.numOfResults > HITS_MAX) && (this.datalistStatus === 'undef')) {
                // const postmethod = this.search.length <= 3 ? 'search' : 'searchPartial';
                this.results = [];
                axios.post('genes/search', {
                    search: this.search
                }).then(response => {
                    this.results = response.data;
                    if (this.results.length > 0) {
                        this.datalistStatus = 'def_perfect';
                    }
                }).catch(function (error) {
                    // console.log(error);
                    throw error;
                });
            } else if (this.search.length <= 2) {
                this.results = [];
                this.datalistStatus = 'undef';
            }
        }
    },
    computed: {
        isInputExist() {
            // 入力値がリストにある場合、Searchボタンを有効にする。（リストにない場合には検索してもヒットがないので検索できないようにする。）
            // if (this.results.some(datalistArr => datalistArr.gene_symbol === this.search)) {
            if (this.results.find(datalistArr => datalistArr === this.search)) {
                return true;
            } else {
                return false;
            }
        },
        showHelpMessage() {
            // 検索文字を入力しているにもかかわらず、リストの値がない場合には、メッセージを出す。
            if (this.results.length == 0 && this.search.length >= 5 && this.datalistStatus === 'def') {
                return true;
            }
            else {
                return false;
            }
        }
    }
}
</script>

<style>
    #search_input .form-control {
        margin-right: 5px;
    }
</style>
